import React from 'react';

import { GridLayout } from '@zapier/common-components';

import { Feature, FeatureData, FeatureDisplayProps } from '../Feature';

type FeatureListProps = {
  /**
   * Number of columns or explicit column sizes. Accepts any valid value for `grid-template-columns`.
   *
   * @default 1
   **/
  columns?: number | string;
  /**
   * A string representing the name of icon to display. Must match a name listed in the ZDS `Icon` component.
   **/
  features: Array<FeatureData>;
  /**
   * The space between rows and columns. Accepts any valid value for `grid-gap` / `gap`. If you want to specify `row-gap` or `column-gap`, use the CSS shorthand form of `gap`, which is `row-gap` followed by `column-gap`.
   *
   * @default 10
   **/
  gap?: number | string;
} & FeatureDisplayProps;

export const FeatureList = ({
  columns = 1,
  features,
  gap = 10,
  ...featureProps
}: FeatureListProps) => (
  <GridLayout columns={columns} gap={gap}>
    {features.map((feature, key) => (
      <Feature
        iconName={feature.iconName}
        key={key}
        label={feature.label}
        {...featureProps}
      />
    ))}
  </GridLayout>
);
